import { useEssentials } from '../../../../contexts/essentials-context';
import {
  appMarketAppPageAppGalleryClick,
  appMarketBackButtonClick,
  appMarketAppPageClick,
} from '@wix/bi-logger-market/v2';
import { appMarketCategorySubCategoryClickFromTheAppPageSrc24Evid159 } from '@wix/bi-logger-app-market-data/v2';
import { RoutePath } from '../../../../models';
import { useJunkYard } from '../../../../contexts';
import { Path } from '../../../../models/junk-yard';

interface QuickInfoActions {
  onBack(appId: string): void;
  onTagClick(
    categorySlug: string,
    subCategory: string,
    appId: string,
    label: 'category' | 'sub_category',
    location: 'top_page' | 'side_category_page',
  ): void;
  onGalleryChange(oldIndex: number, newIndex: number, appId: string): void;
  onCompanyClick(companySlug: string, appId: string): void;
  onReviewsClick(appId: string, reviewsAmount: number): void;
}

export const useQuickInfoActions = (): QuickInfoActions => {
  const { biLogger, router } = useEssentials();
  const { goto } = useJunkYard();

  function onBack(appId: string) {
    biLogger.report(
      appMarketBackButtonClick({
        appId,
        tag_type: 'app_page',
        tag_name: 'app_id',
        location: 'page',
      }),
    );
    router.hasHistory() &&
      router.navigateTo({
        path: RoutePath.BACK,
        payload: undefined,
      });
  }

  function onTagClick(
    categorySlug: string,
    subCategorySlug: string,
    appId: string,
    label: 'category' | 'sub_category',
    location: 'top_page' | 'side_category_page',
  ) {
    biLogger.report(
      appMarketCategorySubCategoryClickFromTheAppPageSrc24Evid159({
        category_name: categorySlug,
        subcategory_name: subCategorySlug,
        label_type: label,
        app_id: appId,
        app_page_location: location,
      }),
    );
    goto({
      path: Path.CATEGORY,
      slug: categorySlug,
      subCategories: label === 'sub_category' ? [subCategorySlug] : undefined,
    });
  }

  function onGalleryChange(oldIndex: number, newIndex: number, appId: string) {
    const action = oldIndex < newIndex ? 'right' : 'left';
    biLogger.report(appMarketAppPageAppGalleryClick({ action, app_id: appId }));
  }

  function onCompanyClick(companySlug: string, appId: string) {
    biLogger.report(
      appMarketAppPageClick({
        app_id: appId,
        cta: 'company_name',
        location: 'info',
        value: companySlug,
      }),
    );
    goto({
      path: Path.DEVELOPER,
      slug: companySlug,
    });
  }

  function onReviewsClick(appId: string, reviewsAmount: number) {
    const reviewTitle = document.querySelector(
      '[data-hook="average-rating-heading"]',
    );
    biLogger.report(
      appMarketAppPageClick({
        app_id: appId,
        cta: 'review_number',
        location: 'info',
        value: reviewsAmount.toString(),
      }),
    );
    reviewTitle?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  return {
    onBack,
    onTagClick,
    onCompanyClick,
    onGalleryChange,
    onReviewsClick,
  };
};
